var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestsPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0042 27.8135H11.9922C11.1638 27.8135 10.4922 28.485 10.4922 29.3135V30.6935C10.4922 31.5219 11.1638 32.1935 11.9922 32.1935H36.0042C36.8326 32.1935 37.5042 31.5219 37.5042 30.6935V29.3135C37.5042 28.485 36.8326 27.8135 36.0042 27.8135Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9922 32.2529V37.5059",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3122 22.5001H10.6782C10.2309 22.4997 9.80206 22.3218 9.48591 22.0054C9.16977 21.6889 8.99219 21.2599 8.99219 20.8126V12.1816C8.99219 11.2501 9.74669 10.4941 10.6782 10.4941H22.3107C23.2437 10.4941 23.9982 11.2501 23.9982 12.1816V20.8126C23.9982 21.7441 23.2437 22.5001 22.3122 22.5001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.635 27.813L18.75 22.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3594 27.813L14.2444 22.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37.5059V32.2529",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 20.8574H33.6105C34.4433 20.8594 35.2415 21.1911 35.8304 21.78C36.4193 22.3689 36.751 23.1671 36.753 23.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.494 17.1064C30.6989 17.1048 29.9369 16.7877 29.3755 16.2246C28.8141 15.6615 28.4992 14.8986 28.5 14.1034C28.5008 13.3083 28.8172 12.546 29.3797 11.9841C29.9423 11.4221 30.7049 11.1064 31.5 11.1064C32.2951 11.1064 33.0577 11.4221 33.6203 11.9841C34.1828 12.546 34.4992 13.3083 34.5 14.1034C34.5008 14.8986 34.1859 15.6615 33.6245 16.2246C33.0631 16.7877 32.3011 17.1048 31.506 17.1064H31.494Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestsPoi);
export default __webpack_public_path__ + "static/media/guests-poi.c8f724a8fcc07868af975c7037ee4dba.svg";
export { ForwardRef as ReactComponent };